import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Icon } from "semantic-ui-react";
import {
  clearRecordingState,
  saveRecording as saveRecordingAction,
  initializeRecordingUtils,
  selectRecordingStatus,
  isAudioChunksEmpty,
  selectAudioChunksLength,
} from "../slices/aaiRecordingUtilitySlice";

const SaveDiscardControls = ({ saveRecording, discardRecording }) => {
  const dispatch = useDispatch();

  // Selectors for Redux state
  const recordingStatus = useSelector(selectRecordingStatus);
  const audioChunksLength = useSelector(selectAudioChunksLength);
  const audioChunksIsEmpty = useSelector(isAudioChunksEmpty);

  return (
    <Grid.Row>
      <Grid.Column textAlign="right">
        {/* Discard Button */}
        <Button
          basic
          disabled={audioChunksIsEmpty} // Disable if there are no audio chunks
          size="small"
          color="red"
          onClick={() => {
            if (discardRecording) {
              discardRecording();
            } else {
              dispatch(clearRecordingState()); // Clear recording state on discard
            }
            console.log("Recording discarded.");
          }}
        >
          <Icon name="cancel" /> Discard
        </Button>

        {/* Save Button */}
        <Button
          basic
          disabled={audioChunksIsEmpty || recordingStatus === "completed"} // Disable if no audio chunks or already saved
          size="small"
          color="green"
          onClick={() => {
            if (saveRecording) {
              saveRecording();
            } else {
              // Use async/await pattern for better control flow
              (async () => {
                try {
                  // Initialize recording utils before saving
                  // await dispatch(initializeRecordingUtils()).unwrap();

                  // Check if initialization was successful
                  const state = await dispatch(saveRecordingAction()).unwrap();
                  console.log("Recording saved successfully.");
                } catch (error) {
                  console.error("Error saving recording:", error);
                }
              })();
            }
          }}
        >
          <Icon name="check" /> Save
        </Button>
      </Grid.Column>
    </Grid.Row>
  );
};

export default SaveDiscardControls;
